// extracted by mini-css-extract-plugin
export var divider = "_39-0";
export var dividerText = "_39-1";